import React from 'react'

const FloatingButton = () => {
    const handleClick = () => {
        const contact = document.getElementById('contact')
        if (!contact) return
        window.scrollTo({
            top: contact.offsetTop,
            behavior: 'smooth'
        })
    }

    return (
        <>
            <button className='fixed sm:hidden bottom-0 w-full z-10 bg-red-600 text-white px-6 py-3 hover:opacity-80' onClick={handleClick}>お問合せはこちら</button>
            <button className='hidden sm:block fixed bottom-10 right-10 z-10 bg-red-600 text-white px-6 py-2 rounded-3xl hover:opacity-80' onClick={handleClick}>お問合せはこちら</button>
        </>
    )
}

export default FloatingButton